import type { CreateInviteInput, CreateUserInput, Feature, Invite, PublicUser } from "@codvero/shared";
import { api, del, get, post } from "./client.ts";

export type AdminUser = PublicUser & { disabledAt: string | null };
export interface ActivityEntry { id: number; at: string; action: string; actorId: string | null; actor: string | null; target: string | null; targetName: string | null; ip: string | null; details: unknown }

export const usersApi = {
  list: () => get<AdminUser[]>("/api/users"),
  create: (input: CreateUserInput) => post<PublicUser>("/api/users", input),
  setFeatures: (id: string, features: Feature[]) => api<PublicUser>(`/api/users/${id}/features`, { method: "PUT", json: { features } }),
  resetPassword: (id: string, password: string) => post<void>(`/api/users/${id}/password`, { password }),
  resetTotp: (id: string) => post<void>(`/api/users/${id}/totp/reset`),
  activity: (q: { actor?: string; kind?: string; before?: number }) => get<ActivityEntry[]>(`/api/users/activity?${new URLSearchParams(Object.entries(q).filter(([, v]) => v !== undefined && v !== "").map(([k, v]) => [k, String(v)]))}`),
  disable: (id: string) => post<void>(`/api/users/${id}/disable`),
  enable: (id: string) => post<void>(`/api/users/${id}/enable`),
  invites: () => get<Invite[]>("/api/users/invites"),
  createInvite: (input: Partial<CreateInviteInput>) => post<Invite>("/api/users/invites", input),
  deleteInvite: (id: string) => del(`/api/users/invites/${id}`),
};
